module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "gutter": 8
    }
  }, [(_vm.rowData.organisation) ? _c('el-col', {
    attrs: {
      "span": this.isManager() ? 14 : 23
    }
  }, [_c('contacts-popover', {
    attrs: {
      "row-data": _vm.rowData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isManager('maintenance') || _vm.isViewOnly()) ? _c('el-col', {
    attrs: {
      "span": _vm.rowData.organisation ? 8 : 23
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": "",
      "disabled": _vm.isViewOnly()
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7807c34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/controls/TicketControls.vue
// module id = 1635
// module chunks = 0